import { axiosService } from "./axiosService";

const userApi = {
    createUser(body) {
        const url = '/user/create';
        return axiosService.post(url, body);
    },
    getUsers() {
        const url = '/get-all-user';
        return axiosService.get(url)
    },
    getUser(id) {
        const url = `/user/${id}`;
        return axiosService.get(url)
    },
    editUser(id, body) {
        const url = `/user/${id}`
        return axiosService.put(url, body)
    },
    deleteUser(id) {
        const url = `/user/delete/${id}`
        return axiosService.delete(url)
    },
    changePassword(body) {
        const url = '/change-password'
        return axiosService.post(url, body)
    },
    getUsersOfStore(id) {
        const url = `/get-users-of-store/${id}`
        return axiosService.get(url)
    },
    changePasswordUser(id, body) {
        const url = `/change-other-password/${id}`
        return axiosService.put(url, body)
    },
    createShopManager(body) {
        const url = '/shop-manager/create'
        return axiosService.post(url, body)
    },
    importShopManager(body) {
        const url = '/shop-manager/import'
        return axiosService.post(url, body)
    },
    updateShopManager(body) {
        const url = '/shop-manager/update'
        return axiosService.put(url, body)
    },
    getAllShopManager() {
        const url = '/get-all-shop-manager'
        return axiosService.get(url)
    }
}

export default userApi;